import { render, staticRenderFns } from "./AccountReferrals.vue?vue&type=template&id=499ae925&scoped=true"
import script from "./AccountReferrals.vue?vue&type=script&lang=ts"
export * from "./AccountReferrals.vue?vue&type=script&lang=ts"
import style0 from "./AccountReferrals.vue?vue&type=style&index=0&id=499ae925&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ae925",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499ae925')) {
      api.createRecord('499ae925', component.options)
    } else {
      api.reload('499ae925', component.options)
    }
    module.hot.accept("./AccountReferrals.vue?vue&type=template&id=499ae925&scoped=true", function () {
      api.rerender('499ae925', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/AccountReferrals.vue"
export default component.exports